import { DAY_LABELS_SHORT } from "./utils";

export function MonthView({ currentMonth, monthGrid, byDay, onPickDay, chipColor, chipTitle, today }) {
  return (
    <div className="sp-card overflow-hidden">
      <div className="grid grid-cols-7">
        {DAY_LABELS_SHORT.map((l) => (
          <div key={l} className="p-2 text-center label-eyebrow bg-[color:var(--sp-subtle)]">{l}</div>
        ))}
        {monthGrid.map((d) => {
          const inMonth = new Date(d + "T00:00:00Z").getUTCMonth() === currentMonth;
          const list = byDay[d] || [];
          return (
            <button key={d} onClick={() => onPickDay(d)} data-testid={`month-day-${d}`}
                    className={`text-left border-t border-l border-[color:var(--sp-border)] min-h-[110px] p-2 transition-colors ${inMonth ? "bg-white" : "bg-[color:var(--sp-bg)]"} hover:bg-[color:var(--sp-subtle)]`}>
              <div className={`text-sm font-black ${d === today ? "text-[color:var(--sp-brand)]" : (inMonth ? "" : "text-[color:var(--sp-text-muted)]")}`}>
                {d.slice(8, 10)}
              </div>
              <div className="mt-1 space-y-0.5">
                {list.slice(0, 3).map((a) => {
                  const c = chipColor(a);
                  return (
                    <div key={a.id} className="text-[10px] px-1.5 py-0.5 rounded truncate" style={{ background: `${c}22`, color: c, borderLeft: `2px solid ${c}` }}>
                      {chipTitle(a).primary}
                    </div>
                  );
                })}
                {list.length > 3 && <div className="text-[10px] text-[color:var(--sp-text-muted)]">+{list.length - 3}</div>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
